import type { LocalPortCall } from './localAolGenerator';

export const getNumericValue = (value: string | number | null | undefined): number | null => {
    if (value === null || value === undefined || value === '') return null;
    const numericValue = typeof value === 'number' ? value : Number(value);
    return Number.isFinite(numericValue) ? numericValue : null;
};

export const compareLocalPortCalls = (left: LocalPortCall, right: LocalPortCall): number => {
    const leftVoyage = getNumericValue(left.voyageNumber);
    const rightVoyage = getNumericValue(right.voyageNumber);
    if (leftVoyage !== null && rightVoyage !== null && leftVoyage !== rightVoyage) {
        return leftVoyage - rightVoyage;
    }
    if (leftVoyage === null && rightVoyage !== null) return 1;
    if (leftVoyage !== null && rightVoyage === null) return -1;

    const leftOrder = getNumericValue(left.portOrderNumber);
    const rightOrder = getNumericValue(right.portOrderNumber);
    if (leftOrder !== null && rightOrder !== null && leftOrder !== rightOrder) {
        return leftOrder - rightOrder;
    }
    if (leftOrder === null && rightOrder !== null) return 1;
    if (leftOrder !== null && rightOrder === null) return -1;

    return left.imosPortCallId - right.imosPortCallId;
};
